import { Grid } from 'antd';

/**
 * True below antd's `md` breakpoint (768px), so JS logic flips at the same
 * pixel as `Col xs/md` and Table column `responsive: ['md']` tags.
 * `useBreakpoint()` returns {} on the first render; treating unknown as
 * desktop avoids a layout flash for the common desktop case.
 */
export function useIsMobile(): boolean {
  const screens = Grid.useBreakpoint();
  return screens.md === false;
}
